import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';


const ClaimBasisInput: InputWithSource = ({ input }) => <GenericSelect label={input.name} input={input} />;

ClaimBasisInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ClaimBasisInput);
